import {initElements} from "../define/shared"

export default function initSideMenu() {
    initElements(".side-menu", menu => {
        const btn = menu.querySelector('.side-menu-btn')
        const blocks = document.querySelectorAll('.wa-block')
        const ul = menu.querySelector('ul')

        blocks.forEach(block => {
            const title = block.querySelector('.wa-title')
            if (title && !parseInt(block.dataset.hide)) {
                const titleText = title.dataset.title ? title.dataset.title : title.textContent
                const titleTextLink = titleText.split(' ').join('-')
                const li = document.createElement('li')
                const link = document.createElement('a')
                link.setAttribute('data-url', titleTextLink)
                link.setAttribute('href', `#${titleTextLink}`)
                link.innerText = titleText

                li.appendChild(link)
                ul.appendChild(li)
                block.setAttribute('data-link', titleTextLink)
            }
        })

        btn.addEventListener('click', () => {
            menu.classList.toggle('is--open')
        })

        ul.querySelectorAll('a').forEach(a => {
            a.addEventListener('click', (e) => {
                const elToScroll = document.querySelector(`[data-link="${a.dataset.url}"]`)
                e.preventDefault()
                ul.querySelectorAll('a').forEach(item => item.classList.remove('is--active'))
                a.classList.add('is--active')

                window.scrollTo({
                    left: 0,
                    top: elToScroll.offsetTop,
                    behavior: "smooth"
                })
            })
        })

        window.addEventListener('scroll', () => {
            menu.classList.remove('is--open')
        })
    })
}
